import api from '@/api';
import { ForexDraftFilter } from "@/feature/Forex/api/draft/forex-draft.interface";
import { isSuccessResponseStatusCode } from "@/api/handler";
import { ForexBuyDraft } from "@/feature/Forex/api/form/forex-form.interface";
import { mapForexDraftList } from "@/feature/Forex/api/form/forex-form.utils";
import { wrapAutoCancellableLast } from "@/api/core/cancellable";

export const $getForexDraftList = async (
	params?: ForexDraftFilter
): Promise<ForexBuyDraft[]> => {
	// return require('./__mock__/draf-list.json').data;

	return api
		.get('foreign-exchange/draft/list', {
			request: { params },
			handler: { disableLoader: true }
		})
		.then(mapForexDraftList);
};

export const $getForexDraftListOnce = wrapAutoCancellableLast(
	$getForexDraftList,
	mapForexDraftList
);

export const $deleteForexDraft = (id: number): Promise<boolean> => api
	.delete('foreign-exchange/draft/' + id, {
		handler: { returnData: false }
	})
	.then(response => isSuccessResponseStatusCode(response?.status));